export default __webpack_public_path__ + "static/media/serenad3.b96b8cb2.png";